module Meevo.Plugins.RoyaltyExport {
    "use strict";

    export enum EntityExclusionsEnum {
        Service = 11044945,
        Product = 11044946,
        Package = 11044947,
        Membership = 11044948,
        GiftCard = 11044949,
        Discount = 11044950
    }

    interface IItem {
        id: Guid,
        displayName: string,
        exclusionEntityEnum?: EntityExclusionsEnum
    }

    interface IExclusions {
        services: IItem[],
        products: IItem[],
        packages: IItem[],
        memberships: IItem[],
        giftCardTypes: IItem[],
        discounts: IItem[]
    }

    export class ExclusionsSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        private context: RoyaltyExportContext;
        public customButtonsSet: Array<Meevo.Components.Controls.IMaintenanceFormCustomButton>;
        public securityKeys = Meevo.Components.Common.SecurityKeys;
        public exclusions: IExclusions = {
            services: [],
            products: [],
            packages: [],
            memberships: [],
            giftCardTypes: [],
            discounts: []
        };
        public service: any;
        public product: any;
        public package: any;
        public membership: any;
        public giftCardType: any;
        public discount: any;
        public filterCriteria: any;

        constructor(protected params: Meevo.Model.ISectionParamsCommonDataService) {
            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.noun,
                params.identityService,
                params.sectionSecurityKey)

            this.context = params['context'];

            this.filterCriteria = {
                excludeIdList: []
            };
        }

        activate(): void {
            this.customButtonsSet = [{
                text: 'LABEL_SCHEDULE_EXPORT',
                classNames: 'meevo-button-lg meevo-bottom-button',
                clickHandler: () => {
                    this.context.scheduleRoyaltyExport()
                },
                disableRules: () => this.mode !== Meevo.Model.MaintenanceFormState.Readonly,
                visibilityRules: () => true,
                securityRules: this.securityKeys.MANAGEMENT_ROYALTYEXPORTSETTINGS_TAB_EXCLUSIONS,
                position: 'left'
            }];

            super.activate();

            if (this.model) {
                this.updateExclusionsModel();
            }
        }

        updateExclusionsModel(): void {
            this.model.exclusions.forEach((item) => {
                item.id = item.entityId;

                switch (item.exclusionEntityEnum) {
                    case EntityExclusionsEnum.Service:
                        item.displayName = `${item.shortcut}: ${item.displayName}`;
                        this.exclusions.services.push(item);
                        break;
                    case EntityExclusionsEnum.Product:
                        item.displayName = `${item.sku}: ${item.displayName}: ${item.variantDisplayName}`;
                        this.exclusions.products.push(item);
                        break;
                    case EntityExclusionsEnum.Package:
                        this.exclusions.packages.push(item);
                        break;
                    case EntityExclusionsEnum.Membership:
                        this.exclusions.memberships.push(item);
                        break;
                    case EntityExclusionsEnum.GiftCard:
                        this.exclusions.giftCardTypes.push(item);
                        break;
                    case EntityExclusionsEnum.Discount:
                        this.exclusions.discounts.push(item);
                        break;
                }
            });
        }

        changeItem(item: any, type: string): void {
            if (item) {
                let baseItem: IItem = {
                    id: item.id,
                    displayName: item.displayName
                };

                switch (type) {
                    case 'services':
                        this.exclusions.services.push(_.extend({}, baseItem, {
                            exclusionEntityEnum: EntityExclusionsEnum.Service,
                            displayName: `${item.shortcut}: ${item.displayName}`
                        }));
                        this.service = null;
                        break;
                    case 'products':
                        this.exclusions.products.push(_.extend({}, baseItem, {
                            exclusionEntityEnum: EntityExclusionsEnum.Product,
                            displayName: `${item.sku}: ${item.displayName}: ${item.variantDisplayName}`
                        }));
                        this.product = null;
                        break;
                    case 'packages':
                        this.exclusions.packages.push(_.extend({}, baseItem, {exclusionEntityEnum: EntityExclusionsEnum.Package}));
                        this.package = null;
                        break;
                    case 'memberships':
                        this.exclusions.memberships.push(_.extend({}, baseItem, {exclusionEntityEnum: EntityExclusionsEnum.Membership}));
                        this.membership = null;
                        break;
                    case 'giftCardTypes':
                        this.exclusions.giftCardTypes.push(_.extend({}, baseItem, {exclusionEntityEnum: EntityExclusionsEnum.GiftCard}));
                        this.giftCardType = null;
                        break;
                    case 'discounts':
                        this.exclusions.discounts.push(_.extend({}, baseItem, {exclusionEntityEnum: EntityExclusionsEnum.Discount}));
                        this.discount = null;
                        break;
                }
            }
        }

        removeItem(item: any) {
            for (let type in this.exclusions) {
                this.exclusions[`${type}`] = this.exclusions[`${type}`].filter(elem => elem.id !== item.id);
            }
        }

        preSave(): any {
            let exclusionsList = {
                exclusions: []
            };

            for (let type in this.exclusions) {
                this.exclusions[`${type}`].forEach((item: IItem) => {
                    exclusionsList.exclusions.push({
                        entityId: item.id,
                        exclusionEntityEnum: item.exclusionEntityEnum
                    });
                });
            }

            this.model = exclusionsList;

            return this.model;
        }
    }
}